<div *ngIf="formOptions == null">
    <mat-spinner></mat-spinner>
</div>

<div *ngIf="formOptions != null">
    <aumico-form [options]="formOptions" [delegate]="this" [data]="data" (formChange)="onFormChange($event)">
        <aumico-button (click)="onCancel()" class="aum-typo-paragraph-s aum-size-medium aum-button"
            >{{ 'aumico_button_cancel' | i18next  }}</aumico-button
        >
    </aumico-form>

    <mat-error *ngIf="isNameExist">{{nameExistenceError | i18next }}</mat-error>
    <mat-error *ngIf="isLegalFormAndAccountBasiscombinationExist">
        {{legalFromAndAccountBasisCombinationError | i18next }}
    </mat-error>

    <div *ngIf="selectedNotesTypes.length > 0" class="preview">
        <h5 class="preview-title">{{ 'aumico_notes_preview' | i18next  }}</h5>
        <div class="notes-form-preview">
            <aumico-notes-template-preview
                [currentLanguage]="currentLanguage"
                [selectedNotesTypes]="selectedNotesTypes"
            >
            </aumico-notes-template-preview>
        </div>
    </div>
</div>
